export const furnitureQueueKey = (furnitureId: number) => `furniture-${furnitureId}`
